// extracted by mini-css-extract-plugin
export default {"dark":"SocialIcons_dark__RpURR","root":"SocialIcons_root__WXBPA","socials":"SocialIcons_socials__eOAKE"};